import React from "react";
import "../css/SiteMap.css";
import ResourceHero from "../components/resources/ResourceHero";

const SiteMap = () => {
  return (
    <>
      <section className="site-map-section">
        <div className="site-map-container">
          <div className="site-map-info">
            <span className="map-tag">Visit Our Campus</span>

            <h2>Sahara Public Secondary School</h2>

            <p>
              We welcome students, parents and visitors to explore our beautiful
              campus. Contact us or use the map to get directions easily.
            </p>

            <div className="map-card">
              <h3>📍 Address</h3>
              <p>
                Krishna Nagar Municipality- Ward No. 01, District: Kapilvastu
                <br />
                Lumbini, Nepal
              </p>
            </div>

            <div className="map-card">
              <h3>📞 Phone</h3>
              <p>+977-984-7040404</p>
            </div>

            <div className="map-card">
              <h3>✉ Email</h3>
              <p> info@sahara.edu.np</p>
            </div>

            <a
              href="https://maps.google.com"
              target="_blank"
              rel="noreferrer"
              className="direction-btn"
            >
              Get Directions
            </a>
          </div>

          <div className="site-map-frame">
            <iframe
              title="Sahara Public Secondary School Location"
              src="https://maps.google.com/maps?q=Krishna%20Nagar%20Municipality%20Ward%20No.%201%20Kapilvastu%20Lumbini%20Nepal&t=&z=15&ie=UTF8&iwloc=&output=embed"
              loading="lazy"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      <section className="campus-reach">
        <div className="campus-reach-container">
          <h2>How To Reach Us</h2>

          <div className="reach-grid">
            <div className="reach-card">
              <h3>🚍 By Bus</h3>
              <p>
                Easily accessible through nearby public transport and school bus
                routes.
              </p>
            </div>

            <div className="reach-card">
              <h3>🚗 By Car</h3>
              <p>
                Spacious parking and easy road connectivity for parents and
                visitors.
              </p>
            </div>

            <div className="reach-card">
              <h3>🏫 Nearby Landmarks</h3>
              <p>Add your nearby landmarks here for easier navigation.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SiteMap;
